module.exports = __webpack_public_path__ + "img/price.4778085a.png";